import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboard\UpdateTemplateDashboardUserPositionController::__invoke
* @see app/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardUserPositionController.php
* @route '/api/template-dashboard-user/update-position'
*/
const UpdateTemplateDashboardUserPositionController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UpdateTemplateDashboardUserPositionController.url(options),
    method: 'post',
})

UpdateTemplateDashboardUserPositionController.definition = {
    methods: ["post"],
    url: '/api/template-dashboard-user/update-position',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\UpdateTemplateDashboardUserPositionController::__invoke
* @see app/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardUserPositionController.php
* @route '/api/template-dashboard-user/update-position'
*/
UpdateTemplateDashboardUserPositionController.url = (options?: RouteQueryOptions) => {
    return UpdateTemplateDashboardUserPositionController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\UpdateTemplateDashboardUserPositionController::__invoke
* @see app/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardUserPositionController.php
* @route '/api/template-dashboard-user/update-position'
*/
UpdateTemplateDashboardUserPositionController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UpdateTemplateDashboardUserPositionController.url(options),
    method: 'post',
})

export default UpdateTemplateDashboardUserPositionController